import React, { useState } from 'react';
import { Modal, Button, Spin } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { confirm } = Modal;

const DeleteProductModal = ({ show, onClose, onDelete }) => {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    await onDelete();
    setDeleting(false);
  };

  return (
    <Modal
      title="Delete Product"
      visible={show}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose} disabled={deleting}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" danger onClick={handleDelete} disabled={deleting}>
          {deleting ? <Spin size="small" /> : 'Delete'}
        </Button>,
      ]}
      icon={<ExclamationCircleOutlined />}
    >
      <p>Are you sure you want to delete this product?</p>
    </Modal>
  );
};

export default DeleteProductModal;
